<template>
 <div class="main-page-container">
  <template v-if="filterdListBlock && filterdListBlock.length > 0">
    <div class="list-account" >
      <div class="data-list">
        <p>Nama </p>
        <p>{{ filterdListBlock[0].Account }}</p>
      </div>
      <div class="data-list">
        <p>HIN </p>
        <p>{{ filterdListBlock[0].HIN }}</p>
      </div>
      <div class="data-list">
        <p>Contract </p>
        <p>{{ filterdListBlock[0].contract_code }}</p>
      </div>
      <div class="data-list">
          <p>Gold Gram </p>
          <p>{{ formatPrice(goldGramParams) }} <small>gr</small></p>
      </div>
    </div>
    <div class="list-card-wrapper">
      <div class="list-grid-header">
        <div class="col-no">No</div>
        <div class="col-block">Data Blocks</div>
        <div class="col-action">Action</div>
      </div>
      <div class="list-rows-container">
        <div class="list-row-item" v-for="(item, i) in displayData" :key="i">
          <div class="col-no cell-number">{{ (currentPage - 1) * perPage + (i + 1)  }}</div>
          <div class="col-block">
            <div class="code-block-display">
              {{ item.code_series }}
            </div>
          </div>
          <div class="col-action">
            <button class="btn-copy-row" @click="copyToClipboard(item.code_series)">Copy</button>
          </div>
        </div>
      </div>
      <div class="list-footer-area">
        <span class="info-text">Showing {{showingFrom}}-{{showingTo}} of {{totalRows}} entries</span>
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" aria-controls="new-table" first-number last-number v-show="totalRows > 10" @change="handlePageChange"></b-pagination>
      </div>
    </div>
  </template>

</div>
</template>
<script>
import dataListBlock from "@/assets/data/multiblock.json"
import { contract } from "@/utils/contract";
export default {
  name: "ParticipanListBlock",
  data() {
    return {
        currentPage: 1,
        perPage: 10,
        totalRows: 10,
        contractId: null,
        goldGramParams: null,
        filterdListBlock: [],
        dataUser: null,
        displayContract: null
    };
  },
  mounted() {
    const id = this.$route.params.id;
    const splitId = id.split("_");
    this.dataUser = {
      account_id: splitId[0],
      hin: splitId[1],
      fullname: splitId[2],
      gram: splitId[3]
    }
    const splitHin = this.$route.params.hin.split("_");
    this.goldGramParams = Number(splitHin[1])
    this.contractId = splitHin[0];
    this.displayContract = contract[this.contractId]
    const filterDataJson = dataListBlock.filter(item => item.HIN === this.dataUser.hin && parseInt(item.Contract) === parseInt(this.contractId));
    console.log(filterDataJson.length)
    this.filterdListBlock = filterDataJson.length !== 0 ? filterDataJson : this.genereteListBlock(this.contractId, this.goldGramParams)
    this.totalRows = this.filterdListBlock.length;
    
  },
  methods: {
    formatPrice(value) {
      let val = Math.round((value + Number.EPSILON) * 100) / 100;
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    paginatedListBlock() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filterdListBlock.slice(start, end);
    },
    handlePageChange(event){
      this.currentPage = event;
      // this.displayData();
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        alert("Kode blok berhasil disalin!");
      }).catch(err => {
        console.error("Gagal menyalin: ", err);
      });
    },
    genereteListBlock(contractId, totalGram){
      const contractType = {
        'DG100': 100,
        'DG1K': 1000,
        'DG001': 0.01,
        'DG1': 1
      }
      const totalData = Math.round((totalGram * 100) / (contractType[contract[contractId]] * 100))
      const result = []
      const getRandomInt = (min, max) => Math.floor(Math.random() * (max-min+1)) + min
      const getRamdonLetter = () => String.fromCharCode(65 + Math.floor(Math.random() * 26))
      for(let i = 0; i < totalData; i++){
        const serialNumber = getRandomInt(10000, 99999)
        const blockCode = `${getRamdonLetter()}${getRandomInt(1,9)}`
        const indexCode = `${getRandomInt(1,9)}-${getRandomInt(1,9)}`
        result.push({
          index: i + 1, 
          code_series: `HM${serialNumber}/${contractId}/${blockCode}/${indexCode}`, 
          Account: this.dataUser.fullname, 
          HIN: this.dataUser.hin,
          contract_code: this.displayContract
        })
      }
      return result
    }
  },
  computed: {
    displayData() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filterdListBlock.slice(start, end);
    },
    goldGram(){
      let totalGram = 0;
      this.filterdListBlock.forEach(item => {
        if(item.contract_code === 'DG001'){
          totalGram += item.QTY * 0.01;
        } else {
          totalGram += item.QTY;
        }
      });
      return totalGram || this.goldGramParams;
    },
    showingFrom() {
      if (this.totalRows === 0) return 0;
      return (this.currentPage - 1) * this.perPage + 1;
    },
    
    showingTo() {
      const calculatedTo = this.currentPage * this.perPage;
      return calculatedTo > this.totalRows ? this.totalRows : calculatedTo;
    }
  }
};
</script>
<style scoped>
.title-page {
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 40px;
}

/* Container Utama */
.main-page-container {
  width: 100%;
  padding: 1rem;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

/* Header Section Layout */
.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
}
.header-title-area h1 {
  font-size: 24px;
  color: #1e293b;
  margin: 0;
  font-weight: 700;
  margin-bottom: 2rem;
}
.header-title-area p {
  font-size: 14px;
  color: #64748b;
  margin: 4px 0 0 0;
}
.header-actions {
  display: flex;
  gap: 12px;
}
.search-input {
  padding: 8px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  width: 220px;
  outline: none;
}
.btn-copy-all {
  background-color: #1e293b;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.list-account {
  margin-bottom: 24px;
}

.data-list {
  display: flex;
  gap: 8px;
  align-items: center;
}

.data-list p:first-child {
  font-size: 11px;
  text-transform: uppercase;
  color: #94a3b8;
  font-weight: 600;
  letter-spacing: 0.5px;
  width: 100px;
}

.data-list p:last-child {
  font-size: 15px;
  font-weight: 700;
  color: #334155;
}

.data-not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 40px;
  color: #64748b;
}
.data-not-found p {
  font-size: 16px;
  color: #64748b;
  margin: 0;
  font-weight: 500;
}

/* Base Wrapper Full-Width Card */
.list-card-wrapper {
  width: 100%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #f1f5f9;
  overflow: hidden;
}

/* Grid Alignment Rules (12 Column Ratio equivalent) */
.list-grid-header, .list-row-item {
  display: flex;
  align-items: center;
  padding: 14px 24px;
}
.col-no { width: 8%; text-align: center; }
.col-block { width: 77%; padding-left: 16px; }
.col-action { width: 15%; text-align: center; }

/* Header Styling */
.list-grid-header {
  background-color: #f8fafc;
  border-bottom: 1px solid #f1f5f9;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Rows & Hover Effects */
.list-rows-container .list-row-item {
  border-bottom: 1px solid #f1f5f9;
  transition: background-color 0.15s ease;
}
.list-row-item:hover {
  background-color: #f8fafc;
}
.cell-number {
  font-size: 14px;
  color: #94a3b8;
  font-weight: 600;
}

/* Code Display Box */
.code-block-display {
  font-family: "Fira Code", "Courier New", monospace;
  font-size: 13.5px;
  background-color: #f1f5f9;
  color: #334155;
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  display: inline-block;
  max-width: 100%;
  word-break: break-all;
}

/* Copy Row Action Button */
.btn-copy-row {
  background: white;
  border: 1px solid #cbd5e1;
  color: #475569;
  padding: 6px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  width: 80px;
  transition: all 0.2s;
}
.btn-copy-row:hover {
  background-color: #f1f5f9;
  color: #1e293b;
}

/* Footer Styling */
.list-footer-area {
  padding: 16px 24px;
  background-color: #f8fafc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #64748b;
}
.pagination-mock {
  display: flex;
  gap: 4px;
}
.btn-page {
  background: white;
  border: 1px solid #e2e8f0;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
}
.btn-page.active {
  background-color: #1e293b;
  color: white;
  border-color: #1e293b;
}
</style>
